<template lang="html">
  <h1 class="wps-template-head">
    <slot></slot>
  </h1>
</template>

<script>
export default {
  name: 'Head'
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.wps-template-head {
  padding: 0 rem(30);
  font-size: rem(28);
  color: #333;
  height: rem(88);
  line-height: rem(88);
  border-bottom: rem(1) solid #e4e4e4;
  font-weight: bolder;
}
</style>
